import axios from "axios";
import React from "react";
import { api } from "../utils/Api";
import { notification, Modal, Form, Input } from "antd";
const QAQCSendInternalPDF = ({
	openModalSend,
	setOpenModalSend,
	selectedLoad,
}) => {
	const [form] = Form.useForm();
	const [apiNotification, contextHolder] = notification.useNotification();

	const openNotification = (type, message, description) => {
		apiNotification[type]({
			message: message,
			description: description,
		});
	};

	const handleSendByEmail = async (values) => {
		try {
			const url =
				api + `/job/get/load/qc/laboratoryreport/email/${selectedLoad.id}`;
			const token = localStorage.getItem("token");
			axios.defaults.headers.common = { Authorization: `Bearer ${token}` };

			const { data } = await axios.post(url, {
				destination: values.email,
			});
			if (data.success) {
				openNotification("success", "Success", "Email Sent");
			} else {
				openNotification("error", "Error", data.message);
			}

			setOpenModalSend(false);
			form.resetFields();
		} catch (err) {
			openNotification("error", "Error", err.message);
		}
	};

	return (
		<Modal
			title="Send PDF via email"
			open={openModalSend}
			onCancel={() => {
				setOpenModalSend(false);
				form.resetFields();
			}}
			onOk={() => form.submit()}
			destroyOnClose
			forceRender
			centered
		>
			<Form form={form} layout="vertical" onFinish={handleSendByEmail}>
				<Form.Item
					label="Email"
					name="email"
					required
					rules={[
						{ required: true, message: "Please fill email" },
						{ type: "email", message: "Invalid email format" },
					]}
				>
					<Input size="large" />
				</Form.Item>
			</Form>
			{contextHolder}
		</Modal>
	);
};

export default QAQCSendInternalPDF;
